/**
 * External dependencies
 */
import { useBlockProps } from '@wordpress/block-editor';
import { FormStepBlock } from '../components/form-step/form-step-block';
import clsx from 'clsx';
import { __ } from '@wordpress/i18n';
import EditFields from './edit-fields';
import Noninteractive from '../components/noninteractive';

const getSectionClass = (sectionId) => `thwcfe_sections_${sectionId || 'default_section'}`;

const Field = ({ field }) => (
    <div key={field.id} className="wc-block-checkout__additional-fields__field">
        <Noninteractive>
            <EditFields field={field} />
        </Noninteractive>
    </div>
);

export const Edit = ({
    attributes,
    setAttributes,
}) => {

    const blockProps = useBlockProps();
    const { sectionData, className } = attributes;    
       
    if (!sectionData) {
        return <div {...blockProps}></div>;
    }

    if (typeof sectionData !== 'object') {
        console.error('Invalid section data:', sectionData);
        return <div {...blockProps}>
            {__('Error: Invalid section data', 'woocommerce')}
        </div>;
    }

    const { fields = {}, show_title } = sectionData;
    const hasFields = Object.keys(fields).length > 0;
    if (!hasFields) {
        return null;
    }
    const Wrapper = show_title ? FormStepBlock : 'div';
    return(
        <div {...blockProps}>
            <Wrapper
                id={sectionData.id}
                className={clsx('wc-block-checkout__additional-fields', sectionData.cssclass)}
                {...(show_title && {
                    setAttributes,
                    attributes
                })}
            >
                <div>
                    { Object.entries(fields).map(([fieldKey, field]) => {
                        return (
                            <Field 
                                key={field.id || fieldKey} 
                                field={field} 
                            />
                        );
                    })}
                </div>
            </Wrapper>
        </div>
    );
    /*return (
        <div {...blockProps}>
            <FormStepBlock
                setAttributes={setAttributes}
                attributes={attributes}
                className={clsx(
                    'wc-block-checkout__th-additional-section-fields',
                    className
                )}
            >
                { Object.entries(fields).map(([fieldKey, field]) => {
                    return (
                        <Field 
                            key={field.id || fieldKey} 
                            field={field} 
                        />
                    );
                })}
            </FormStepBlock>
        </div>
    );*/
};
export const Save = ( { attributes }) => {

	const { sectionData } = attributes;
    const sectionClass = getSectionClass(sectionData?.id);
    return (
        <div className={sectionClass} >   
            
        </div>
    );
};